
import { useEffect, useRef } from 'react';

/**
 * Hook to handle initial data loading for the admin page
 */
export const useAdminInitialLoad = (
  refreshAdminData: () => Promise<any>,
  refreshAttendees: () => Promise<any>,
  recordAction: (actionType: string, adminName: string, details?: string) => void,
  adminName: string,
  isLoading: boolean
) => {
  // Refs to track if initial load was performed
  const initialLoadPerformed = useRef(false);
  const recordedPageAccess = useRef(false);

  // Record page load only once
  useEffect(() => {
    if (!isLoading && !recordedPageAccess.current) {
      recordedPageAccess.current = true;
      recordAction('other', adminName, 'Admin page accessed');
    }
  }, [recordAction, adminName, isLoading]);
  
  // Force refresh data on initial load - ONLY ONCE
  useEffect(() => {
    const initialLoad = async () => {
      if (initialLoadPerformed.current) return;
      
      initialLoadPerformed.current = true;
      
      try {
        await refreshAdminData();
        await refreshAttendees();
      } catch (error) {
        // Silent error
      }
    };
    
    initialLoad();
  }, [refreshAdminData, refreshAttendees]);
};
